import { Button, Input, Option, Select } from '@material-tailwind/react'
import React from 'react'

const AddEventForm = ({eventName,setEventName,eventYoutube,setEventYoutube,eventLocation,setEventLocation,eventUrl,setEventUrl,eventMap,setEventMap,eventPrice,setEventPrice,eventDate,setEventDate,eventDescription,setEventDescription,eventStatus,setEventStatus,addCoverImage,addBanner,banner,setBanner,coverImage,setCoverImage,addEvents}) => {
  return (
    <div className='ml-[20rem] overflow-y-scroll' >
        <div>
            <h3 className='font-[NeueBold] py-2 text-[2rem]' >Add Events</h3>
            <div className='my-3 py-3 px-6 bg-white rounded-lg' >
                <h3 className='font-[NeueMedium] my-2 text-[1rem]' >Add Event Details</h3>
                <div className=' flex items-center justify-start flex-wrap gap-4 ' >
            <div className='w-[350px]' >
                <Input value={eventName} onChange={(e)=>setEventName(e.target.value)} label='Event Name' />
            </div>
            <div className='w-[350px]' >
                <Input value={eventPrice} onChange={(e)=>setEventPrice(e.target.value)} label='Event Price' />
            </div>
            <div className='w-[350px]' >
                <Input value={eventLocation} onChange={(e)=>setEventLocation(e.target.value)} label='Event Location' />
            </div>
            <div className='w-[350px]' >
                <Input value={eventDescription} onChange={(e)=>setEventDescription(e.target.value)} label='Event Description' />
            </div>
            <div className='w-[350px]' >
                <Input value={eventMap} onChange={(e)=>setEventMap(e.target.value)} label='Event Map' />
            </div>
            <div className='w-[350px]' >
                <Input value={eventYoutube} onChange={(e)=>setEventYoutube(e.target.value)} label='Youtube Video' />
            </div>
            <div className='w-[350px]' >
                <Input value={eventUrl} onChange={(e)=>setEventUrl(e.target.value)} label='Event Booking Url' />
            </div>
            <div className='w-[350px]' >
                <Input type='date' value={eventDate} onChange={(e)=>setEventDate(e.target.value)} label='Event Date' />
            </div>
            <div className='w-[350px]' >
                <Select value={eventStatus} onChange={(e)=>setEventStatus(e)} label='Event Status'>
                    <Option value='upcoming' >Upcoming</Option>
                    <Option value='booked' >Booked</Option>
                    <Option value='completed' >Completed</Option>
                </Select>
            </div>
        </div>
            </div>
            <div className='mr-3 bg-white px-6 py-6  rounded-md my-2' >
        <h3 className='mb-2 font-[NeueMedium]' >Event Cover Image</h3>
        <div>
        <div>
                     <form  onSubmit={addCoverImage} className='form flex items-center justify-center flex-col my-6 '>
        <input type='file' />
        <Button className='my-6' type='submit' size="md">Upload Image</Button>
      </form>
      
                </div>
                <div className='flex items-center justify-start gap-6' >
                   
                         { coverImage?.length !== 0 &&  <div className='flex items-center justify-start gap-6' >
                                <img className='w-[200px] h-[200px]' src={coverImage} />
                            </div>}
                       
                </div>
        </div>
       
        </div>
        <div className='mr-3 bg-white px-6 py-6  rounded-md my-2' >
        <h3 className='mb-2 font-[NeueMedium]' >Event Banner Image</h3>
        <div>
        <div>
                     <form  onSubmit={addBanner} className='form flex items-center justify-center flex-col my-6 '>
        <input type='file' />
        <Button className='my-6' type='submit' size="md">Upload Image</Button>
      </form>
      
                </div>
                <div className='flex items-center justify-start gap-6' >
                   
                         { banner?.length !== 0 &&  <div className='flex items-center justify-start gap-6' >
                                <img className='w-[200px] h-[200px]' src={banner} />
                            </div>}
                       
                </div>
        </div>
       
        </div>
        <div className='flex items-center justify-end mx-2' >
            <Button onClick={addEvents} className='my-3' >Add Event</Button>
        </div>
        </div>
    </div>
  )
}

export default AddEventForm